module.exports = __webpack_public_path__ + "src/img/menu-toggler.5f7b96cf.svg";